import * as React from "react";
import { API } from "../API";
import { Loading, loading, isLoading } from "../Loading";
import { DocumentOverlayContentComponent } from "../components/widgets/DocumentOverlayContentComponent";
import { HRAppTemporaryDocument, SubsectionDocumentData } from "../messages/HR";
import { CaregiverCertification, HRSubSectionId } from "../messages/ObjectIds";
import { useState } from "react";
import { useEffect } from "react";
import { useCallback } from "react";

interface DocumentOverlayActivityProps {
    api: API;
    subSectionDocument: SubsectionDocumentData;
    subSectionId: HRSubSectionId;
    selectedCertification: CaregiverCertification;
    onConfirm: () => void;
    onCancelClick: () => void;
}

const DocumentOverlayActivity = (props: DocumentOverlayActivityProps) => {
    const [tempDocData, setTempDocData] = useState<HRAppTemporaryDocument | Loading>(loading());
    const [showInternetError, setShowInternetError] = useState<boolean | Loading>(false);

    const getPDFUrl = useCallback(async () => {
        const temp = await props.api.getCaregiverGeneratedDocument(props.subSectionId, props.selectedCertification);
        setTempDocData(temp);
    }, []);

    useEffect(() => {
        getPDFUrl();
    }, []);

    const handleConfirmClick = () => {
        if (isLoading(tempDocData)) {
            throw new Error("The impossible happened");
        }

        setShowInternetError(loading());
        props.api.confirmCaregiverDocument(
            props.subSectionId,
            {
                bucket: tempDocData.bucket,
                key: tempDocData.key,
                docType: tempDocData.docType
            });

        props.onConfirm();
    };

    return (
        <DocumentOverlayContentComponent
            tempPdf={tempDocData}
            onCancelClick={() => props.onCancelClick()}
            onConfirmClick={() => handleConfirmClick()}
        />
    );
};

export default DocumentOverlayActivity;



// WEBPACK FOOTER //
// ./src/activities/DocumentOverlayActivity.tsx